import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const en = {
  app: {
    name: "EXAM/OS",
    tagline: "Examination Platform",
  },
  nav: {
    dashboard: "Dashboard",
    exams: "Exams",
    results: "My Results",
    certificates: "Certificates",
    leaderboard: "Leaderboard",
    pricing: "Pricing",
    question_bank: "Question Bank",
    analytics: "Analytics",
    people: "People",
    institutions: "Institutions",
    proctor: "Live Proctor",
    settings: "Settings",
    overview: "Overview",
    all_users: "All Users",
    live_monitor: "Live Monitor",
    sign_out: "Sign out",
    signed_in_as: "Signed in as",
  },
  auth: {
    sign_in: "Sign in",
    register: "Register",
    welcome_back: "Welcome back",
    use_account: "Use your account to continue.",
    email: "Email",
    password: "Password",
    full_name: "Full Name",
    role: "Role",
    institution: "Institution",
    create_account: "Create account",
    sign_in_btn: "Sign in",
    no_account: "No account?",
    have_account: "Already have an account?",
    continue_google: "Continue with Google",
    quick_demo: "Quick demo login",
    or: "or",
  },
  common: {
    save: "Save",
    cancel: "Cancel",
    loading: "Loading…",
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    submit: "Submit",
    back: "Back",
    continue: "Continue",
    language: "Language",
  },
  exam: {
    start: "Start",
    resume: "Resume",
    duration: "Duration",
    questions: "Questions",
    total_marks: "Total Marks",
    passing: "Passing",
    negative_marking: "Negative Marking",
    in_progress: "Exam in progress",
    time_remaining: "Time remaining",
    submit_exam: "Submit Exam",
    next: "Next",
    previous: "Previous",
    mark_review: "Mark for review",
    answered: "Answered",
    unanswered: "Unanswered",
    current: "Current",
  },
};

const es = {
  app: { name: "EXAM/OS", tagline: "Plataforma de Exámenes" },
  nav: {
    dashboard: "Panel", exams: "Exámenes", results: "Mis Resultados",
    certificates: "Certificados", leaderboard: "Clasificación", pricing: "Precios",
    question_bank: "Banco de preguntas", analytics: "Analíticas", people: "Personas",
    institutions: "Instituciones", proctor: "Supervisión", settings: "Ajustes",
    overview: "Resumen", all_users: "Todos los usuarios", live_monitor: "Monitor en vivo",
    sign_out: "Cerrar sesión", signed_in_as: "Conectado como",
  },
  auth: {
    sign_in: "Iniciar sesión", register: "Registrarse", welcome_back: "Bienvenido de nuevo",
    use_account: "Usa tu cuenta para continuar.", email: "Correo", password: "Contraseña",
    full_name: "Nombre completo", role: "Rol", institution: "Institución",
    create_account: "Crear cuenta", sign_in_btn: "Iniciar sesión",
    no_account: "¿Sin cuenta?", have_account: "¿Ya tienes cuenta?",
    continue_google: "Continuar con Google", quick_demo: "Inicio rápido demo", or: "o",
  },
  common: {
    save: "Guardar", cancel: "Cancelar", loading: "Cargando…", create: "Crear",
    edit: "Editar", delete: "Eliminar", submit: "Enviar", back: "Volver",
    continue: "Continuar", language: "Idioma",
  },
  exam: {
    start: "Iniciar", resume: "Reanudar", duration: "Duración", questions: "Preguntas",
    total_marks: "Puntos totales", passing: "Aprobado", negative_marking: "Puntos negativos",
    in_progress: "Examen en curso", time_remaining: "Tiempo restante",
    submit_exam: "Enviar examen", next: "Siguiente", previous: "Anterior",
    mark_review: "Marcar para revisar", answered: "Respondida", unanswered: "Sin responder",
    current: "Actual",
  },
};

const hi = {
  app: { name: "EXAM/OS", tagline: "परीक्षा मंच" },
  nav: {
    dashboard: "डैशबोर्ड", exams: "परीक्षाएँ", results: "मेरे परिणाम",
    certificates: "प्रमाणपत्र", leaderboard: "रैंकिंग", pricing: "मूल्य",
    question_bank: "प्रश्न बैंक", analytics: "विश्लेषण", people: "उपयोगकर्ता",
    institutions: "संस्थान", proctor: "निगरानी", settings: "सेटिंग्स",
    overview: "अवलोकन", all_users: "सभी उपयोगकर्ता", live_monitor: "लाइव मॉनिटर",
    sign_out: "साइन आउट", signed_in_as: "साइन इन है",
  },
  auth: {
    sign_in: "साइन इन", register: "रजिस्टर", welcome_back: "वापसी पर स्वागत है",
    use_account: "जारी रखने के लिए अपना खाता उपयोग करें।", email: "ईमेल", password: "पासवर्ड",
    full_name: "पूरा नाम", role: "भूमिका", institution: "संस्थान",
    create_account: "खाता बनाएं", sign_in_btn: "साइन इन",
    no_account: "खाता नहीं है?", have_account: "पहले से खाता है?",
    continue_google: "Google से जारी रखें", quick_demo: "त्वरित डेमो", or: "या",
  },
  common: {
    save: "सहेजें", cancel: "रद्द करें", loading: "लोड हो रहा है…", create: "बनाएँ",
    edit: "संपादित", delete: "हटाएँ", submit: "जमा करें", back: "वापस",
    continue: "जारी रखें", language: "भाषा",
  },
  exam: {
    start: "शुरू", resume: "जारी रखें", duration: "अवधि", questions: "प्रश्न",
    total_marks: "कुल अंक", passing: "उत्तीर्ण", negative_marking: "ऋणात्मक अंकन",
    in_progress: "परीक्षा जारी है", time_remaining: "शेष समय",
    submit_exam: "परीक्षा जमा करें", next: "अगला", previous: "पिछला",
    mark_review: "समीक्षा के लिए चिह्नित", answered: "उत्तर दिया", unanswered: "बिना उत्तर",
    current: "वर्तमान",
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, es: { translation: es }, hi: { translation: hi } },
    lng: localStorage.getItem("locale") || "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export const LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "hi", label: "हिन्दी" },
];

export default i18n;
